import { invibes } from '../../invibesComponent/invibes';

export default {
    response: null,
    init() {
        sessionStorage.setItem('user-loaded', 'false');

        this.makeRequest('GET', `${import.meta.env.VITE_MY_LETUDIANT_URL}/api/users/me`).then((res) => {
            this.response = JSON.parse(res);

            sessionStorage.setItem('user', res);
            sessionStorage.setItem('user-loaded', 'true');

            document.dispatchEvent(new CustomEvent('userSessionUpdated'));

            this.dataLayerPushUser();

            if (this.response?.content?.connected) {
                invibes.setCookie(this.response.content.user);
            }
        }).catch((err) => {
            // eslint-disable-next-line no-console
            console.error(err);
        });
    },
    makeRequest(method, url) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open(method, url);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.withCredentials = true;
            xhr.onload = function handleRequestLoad() {
                if (this.status >= 200 && this.status < 300) {
                    resolve(xhr.response);
                } else {
                    // eslint-disable-next-line prefer-promise-reject-errors
                    reject({
                        status: this.status,
                        statusText: xhr.statusText,
                    });
                }
            };
            xhr.onerror = function handleRequestError() {
                // eslint-disable-next-line prefer-promise-reject-errors
                reject({
                    status: this.status,
                    statusText: xhr.statusText,
                });
            };
            xhr.send();
        });
    },
    isConnected() {
        return this.response?.content?.connected || false;
    },
    dataLayerPushUser() {
        if (typeof window.dataLayer === 'undefined') {
            return;
        }

        const userObject = {
            event: 'etuEventUser',
        };
        if (this.isConnected()) {
            userObject.userLogged = 'Oui';
            const userData = this.response.content.user;
            if (userData.userProfile) {
                userObject.userProfile = userData.userProfile;
            }
            if (userData.userNiveauEtude) {
                userObject.userNiveauEtude = userData.userNiveauEtude;
            }
            if (userData.userFiliere) {
                userObject.userFiliere = userData.userFiliere;
            }
            if (userData.userDomaine) {
                userObject.userDomaine = userData.userDomaine;
            }
            if (userData.optins) {
                userObject.userNewsletter = userData.optins.promo ? 'Oui' : 'Non';
            }

            userObject.user_data = {
                email: userData.email ?? '',
                phone_number: userData.phone_number ?? '',
                address: {
                    first_name: userData.firstname ?? '',
                    last_name: userData.lastname ?? '',
                    postal_code: userData.zipcode ?? '',
                    country: userData.country ?? '',
                },
            };
        } else {
            userObject.userLogged = 'Non';
        }

        window.dataLayer.push(userObject);
    },
};
